import { defineComponent as _defineComponent } from 'vue'
import SyncTargetImages from './SyncTargetImages.vue'
import { computed, ref, toRef } from 'vue'
import { formatDateTimeWithYear } from '@/utils/date-formatting'
import { useRouter } from 'vue-router/composables'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsText from '@/components/vision/VsText.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsCard from '@/components/vision/VsCard.vue'
import {
  BatchSyncStatus,
  useBatchSyncStates,
} from '@/components/batches/useBatchSyncStates'
import { SyncTarget } from '@/models/invoice'
import { useBatchStates } from '@/components/batches/useBatchStates'


export default /*#__PURE__*/_defineComponent({
  __name: 'BatchSyncCard',
  props: {
    invoiceId: null,
    target: null
  },
  setup(__props: any) {

const props = __props as {
  invoiceId: string
  target: SyncTarget
}


const router = useRouter()

const batchIdRef = toRef(props, 'invoiceId')
const targetRef = toRef(props, 'target')
const targetIdRef = computed(() => targetRef.value.id)
const {
  syncTarget,
  syncFailureMessage,
  lastSyncedAt,
  syncStatus,
  refetchSyncTargets,
} = useBatchSyncStates(batchIdRef, targetIdRef)

const isManuallyRefetching = ref(false)
const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
const manualRefetchSyncTargets = async () => {
  try {
    isManuallyRefetching.value = true
    await Promise.all([refetchSyncTargets(), sleep(250)])
  } catch (err) {
  } finally {
    isManuallyRefetching.value = false
  }
}

const { batchHasLineItems, batchClientName } = useBatchStates(batchIdRef)

const buttonLabel = computed(() => {
  if (syncStatus.value === BatchSyncStatus.NoSyncTarget) {
    return `Sync to ${batchClientName.value}`
  } else if (
    syncStatus.value === BatchSyncStatus.AwaitingInitialSync ||
    syncStatus.value === BatchSyncStatus.UpdatesPending
  ) {
    return 'Sync pending...'
  } else {
    return 'View details'
  }
})

const buttonStyleType = computed(() => {
  if (
    syncStatus.value === BatchSyncStatus.SyncSuccess ||
    syncStatus.value === BatchSyncStatus.SyncFailure
  ) {
    return 'secondary'
  }
  return 'primary'
})

const statusText = computed(() => {
  if (syncStatus.value === BatchSyncStatus.NoSyncTarget) {
    return 'Not synced yet'
  } else if (syncStatus.value === BatchSyncStatus.AwaitingInitialSync) {
    return 'Queued (waiting on the web connector)'
  } else if (syncStatus.value === BatchSyncStatus.UpdatesPending) {
    return 'Queued (updates detected)'
  } else if (syncStatus.value === BatchSyncStatus.SyncSuccess) {
    return `Synced successfully to ${
      batchClientName.value
    }\nOccurred ${formatDateTimeWithYear(lastSyncedAt.value)}`
  } else if (syncStatus.value === BatchSyncStatus.SyncFailure) {
    return 'Sync failed'
  }
  return ''
})

// todo: we need a better way to get icons
const logoName = computed(() =>
  targetRef.value.name.toLowerCase().includes('quickbooks')
    ? 'quickbooks'
    : 'ironsight'
)

const handleSyncClicked = () => {
  if (syncStatus.value === BatchSyncStatus.NoSyncTarget) {
    router.push({
      name: 'job-search-batches-info-panel-sync-details-edit',
      params: {
        syncTargetId: targetIdRef.value,
      },
    })
  } else {
    router.push({
      name: 'job-search-batches-info-panel-sync-details-edit',
      params: {
        syncTargetId: targetIdRef.value,
      },
      query: {
        initialCustomerName: syncTarget.value?.customerName,
      },
    })
  }
}

return { __sfc: true,props, router, batchIdRef, targetRef, targetIdRef, syncTarget, syncFailureMessage, lastSyncedAt, syncStatus, refetchSyncTargets, isManuallyRefetching, sleep, manualRefetchSyncTargets, batchHasLineItems, batchClientName, buttonLabel, buttonStyleType, statusText, logoName, handleSyncClicked, SyncTargetImages, VsWrapper, VsText, VsButton, VsCard, BatchSyncStatus }
}

})